import React from 'react';
import { TableProps } from './Table.config';
import { getTableBodyJSX, getTableHeaderJSX } from './Table.helpers';

const Table: React.FC<TableProps> = ({
  columns,
  width,
  type,
  handleSort,
  handleClick,
  data,
  contentClassName = '',
}) => {
  const fixedColumnIndices = columns.reduce((acc, curr, currentIndex) => {
    if (curr.fixed)
      return {
        ...acc,
        [currentIndex]: true,
      };
    return acc;
  }, {});

  let tableData = data;

  if (width === 1) {
    tableData = tableData.map((datum, index) => {
      return {
        ...datum,
        data: datum.data.filter((_, index) => fixedColumnIndices[index]),
      };
    });
  }

  const TABLE: JSX.Element[][] = [
    getTableHeaderJSX({ columns, width, type, handleSort }),
    ...getTableBodyJSX({
      data: tableData,
      width,
      handleClick,
      contentClassName,
    }),
  ];

  return (
    <div className={'w-full h-full overflow-auto'}>
      {TABLE.map((arr, i) => {
        const isBody =
          arr.length > 0 &&
          arr[0].key !== null &&
          arr[0].key.toString().includes('table-data_');

        return (
          <div
            key={i}
            className={`inline-block whitespace-nowrap min-w-full ${
              i === 0 ? 'sticky top-0 z-10' : ''
            }`}
          >
            <div
              className={`flex ${
                width === 1 && isBody && 'hover:border hover:border-grey-50'
              }`}
            >
              {arr.map((el, j) => {
                return (
                  <div
                    className={`flex w-full ${!j && 'sticky left-0'}`}
                    key={j}
                  >
                    {el}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Table;
